// extracted by mini-css-extract-plugin
export default {"currencyAmount":"CurrencyAmount_currencyAmount__gJNIO","symbol":"CurrencyAmount_symbol__L2uJA","spacer":"CurrencyAmount_spacer__A7THY","amount":"CurrencyAmount_amount__TOZpx"};